<template>
  <div class="add-course">
    <van-form class="base-course-form" input-align="right" error-message-align="right">
      <div class="tip1">购买同一课程的学员，才能一起入班和上课。</div>
      <van-field
        v-model="params.curriculumInfo.curriculumName"
        label="课程名称"
        required
        input-align="right"
        placeholder="请输入课程名称"
        maxlength="50"
        format-trigger="onBlur"
        :formatter="v => v.trim()"
      />

      <div class="txtbar"><div class="txt">课程授权</div></div>
      <van-field
        class="no-border"
        name="picker"
        required
        v-model="campusText"
        :right-icon="'arrow'"
        placeholder="请选择"
        readonly
        @click.stop="x3chooseCampus()"
        :rules="[{ required: true, message: '必填', trigger: 'onChange' }]"
      >
        <template #label>
          <div class="lab">
            可用校区
            <div @click.stop class="popover-wrap">
              <van-popover
                v-model="showPopover1"
                trigger="click"
                placement="top-start"
                theme="dark"
                :offset="[-8, 4]"
              >
                仅可用校区可使用此课程进行收费
                <!-- 可将课程用于报名收费、线上商城销售的校区 -->
                <template #reference>
                  <van-icon name="question-o" class="tips-icon" />
                </template>
              </van-popover>
            </div>
          </div>
        </template>
      </van-field>
      <div class="campus-box" v-if="params.curriculumAvailableCampusDtos.length > 0">
        <div
          v-for="(item, index) in params.curriculumAvailableCampusDtos"
          :key="item.id"
          class="campus-name"
          @click="removeCampus(index)"
        >
          {{ item.name }}<van-icon name="cross" class="delete-icon" />
        </div>
      </div>

      <div class="txtbar">
        <div class="txt">课程属性</div>
        <div class="txt txtbtn" @click="$router.push('/basePirceDimension?moreDimension=true')">
          设置
        </div>
      </div>
      <div class="sub-wrap" v-if="params.priceDimensionDtos.length > 0">
        <van-field
          readonly
          clickable
          name="picker"
          v-for="(item, idx) in params.priceDimensionDtos"
          :label="item.dimensionName"
          :value="item.dimensionValue"
          placeholder="请选择"
          :key="item.name"
          :right-icon="'arrow'"
          @click="toOpenPopupPicker(item)"
        >
          <template #label>
            <div class="dimension-field-name">
              <van-icon
                class-prefix="vxs-icon"
                name="system_del"
                size="var(--fs-lg)"
                color="var(--c3)"
                @click.stop="removeDimension(idx)"
              />
              {{ item.dimensionName }}
            </div>
          </template>
        </van-field>
      </div>
      <div v-else class="no-dimens">未设置课程属性</div>

      <div class="txtbar">
        <div class="txt">计费方式</div>
      </div>
      <div class="cell-wrapper" v-if="sw1">
        <div class="typebar van-hairline--bottom">
          <div class="txt">按{{lessonUnit}}计费</div>
          <van-switch v-model="sw1_check" size="24" />
        </div>
        <template v-if="sw1_check">
          <div class="typebar">
            <div class="txt">价格设置</div>
            <div class="txt txtbtn" @click="gotoSetPrice(manual)">
              {{ manual.priceItemDetailList.length > 0 ? `去修改` : `去设置` }}
            </div>
          </div>
          <div v-if="manual.priceItemDetailList.length > 0" style="padding-bottom: 12px">
            <course-price :chargeType="1" :list="manual.priceItemDetailList" />
          </div>
        </template>
      </div>

      <div class="cell-wrapper" style="margin-top: 12px" v-if="sw2">
        <div class="typebar van-hairline--bottom">
          <div class="txt">按天自动计费</div>
          <van-switch v-model="sw2_check" size="24" />
        </div>
        <template v-if="sw2_check">
          <div class="typebar">
            <div class="txt">价格设置</div>
            <div class="txt txtbtn" @click="gotoSetPrice(auto)">
              {{ auto.priceItemDetailList.length > 0 ? `去修改` : `去设置` }}
            </div>
          </div>

          <div v-if="auto.priceItemDetailList.length > 0" style="padding-bottom: 12px">
            <course-price :chargeType="2" :list="auto.priceItemDetailList" />
          </div>
        </template>
      </div>
    </van-form>
    <pageFooterBtn btnText="确定" :loading="submiting" loading-text="提交中..." @click="submit" />

    <van-popup :value="showPopup1" position="bottom" @click-overlay="close1">
      <van-picker
        :columns="dimensionValueList"
        :value-key="'dimensionValue'"
        :default-index="dimensionValueIndex"
        :show-toolbar="true"
        @confirm="pickerSubjectConfirm"
        @cancel="close1"
      />
    </van-popup>
  </div>
</template>

<script>
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';
import CoursePrice from './child/course-price';

export default {
  name: 'course-add',
  components: {
    pageFooterBtn,
    CoursePrice,
  },
  data() {
    let coruseId = this.$vxRoute.query.id || '';
    return {
      pageTitle: coruseId ? '编辑课程' : '新增课程',
      id: coruseId,
      params: {
        availableCampusIds: [app.teacher.campusId],
        curriculumAvailableCampusDtos: [app.teacher.campus],
        priceItemDtos: [],
        curriculumInfo: {
          id: '',
          curriculumName: '',
        },
        priceDimensionDtos: [],
      },
      sw1: false,
      sw1_check: true,
      sw2: false,
      sw2_check: true,
      manual: {
        chargeType: 1,
        priceItemDetailList: [],
      },
      auto: {
        chargeType: 2,
        priceItemDetailList: [],
      },

      showPopover1: false,
      // 原有属性映射
      beforeDimensMap: {},
      showPopup1: false,
      // 当前要选择的属性的可选值列表
      dimensionValueList: [],
      // 当前选中的属性值下标
      dimensionValueIndex: -1,

      submiting: false,
    };
  },
  computed: {
    ...Vuex.mapState(['lessonUnit']),
    campusText() {
      if (this.params.curriculumAvailableCampusDtos.length > 0) {
        return `已选${this.params.curriculumAvailableCampusDtos.length}个校区`;
      } else {
        return '';
      }
    },
  },
  methods: {
    async render() {
      this.getConfig();
      await this.getData();
    },
    async getConfig() {
      let ret = await this.$api.findChargeMode();
      ret.data.forEach(item => {
        if (item.chargeType == 1) {
          this.sw1 = !!item.status;
        } else if (item.chargeType == 2) {
          this.sw2 = !!item.status;
        }
      });
    },
    async getData() {
      if (this.id) {
        let ret = await this.$api.findCurriculumPriceItem({
          curriculumId: this.id,
        });
        this.params = ret.data;
        this.manual = ret.data.manual;
        this.auto = ret.data.auto;
        this.params.availableCampusIds = this.params.curriculumAvailableCampusDtos.map(
          itm => itm.id
        );

        ret.data.priceDimensionDtos.forEach(itm => {
          this.beforeDimensMap[itm.basePriceDimensionId] = itm;
        });
      }
      this.handleDimensionData(this.id ? 'init' : '');
    },
    // 课程属性处理
    async handleDimensionData(type) {
      let ret = await this.$api.basePriceDimensionDetailList({
        // priceDimensionStatus: 1,
        page: {
          pageNum: 1,
          pageSize: 9999,
        },
      });

      // 如果是编辑，则第一次取原课程上的属性
      if (type == 'init') {
        let dimensMap = {};
        ret.data.forEach(itm => {
          dimensMap[itm.id] = itm;
        });
        this.params.priceDimensionDtos.forEach(itm => {
          itm.basePriceDimensionDetailList =
            dimensMap[itm.basePriceDimensionId].basePriceDimensionDetailList;
        });
      } else {
        let list = []
        // 如果是新增或者是设置了属性，则...
        ret.data.forEach(itm => {
          if (itm.priceDimensionStatus) {
            let idKey = itm.id;
            let dimenObj = {
              ...itm,
              basePriceDimensionId: idKey,
              basePriceDimensionDetailId: '',
              dimensionValue: '',
            };
            if (this.beforeDimensMap[idKey]) {
              dimenObj.basePriceDimensionDetailId =
                this.beforeDimensMap[idKey].basePriceDimensionDetailId;
              dimenObj.dimensionValue = this.beforeDimensMap[idKey].dimensionValue;
            }
            list.push(dimenObj)
          }
        });
        this.params.priceDimensionDtos = list
      }
    },
    // 选择属性
    async toOpenPopupPicker(item) {
      this.dimensionValueList = item.basePriceDimensionDetailList;
      this.dimensionValueList.some((itm, index) => {
        if (item.basePriceDimensionDetailId == itm.id) {
          this.dimensionValueIndex = index;
        }
      });
      this.showPopup1 = true;
      let ret = await new Promise(rsv => {
        this._rsv = rsv;
      });
      console.log(ret);
      item.basePriceDimensionDetailId = ret.id;
      item.dimensionValue = ret.dimensionValue;
    },
    // 确认属性值选择
    pickerSubjectConfirm(v) {
      this._rsv(v);
      this.close1();
    },
    close1() {
      this.showPopup1 = false;
    },
    // 移除属性
    removeDimension(idx) {
      this.params.priceDimensionDtos.splice(idx, 1);
    },

    // 选择校区
    async x3chooseCampus() {
      let res = await app.x3.side.xsCampus({
        ids: this.params.availableCampusIds,
        list: this.params.curriculumAvailableCampusDtos,
      });
      this.params.availableCampusIds = res.ids;
      this.params.curriculumAvailableCampusDtos = res.list;
    },
    // 移除校区
    removeCampus(idx) {
      this.params.availableCampusIds.splice(idx, 1);
      this.params.curriculumAvailableCampusDtos.splice(idx, 1);
    },
    // 设置收费方式
    async gotoSetPrice(item) {
      let res = await new Promise((resolve, reject) => {
        app.router.push('/course/add/price', route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = {
            type: item.priceItemDetailList.length > 0 ? 'edit' : 'add',
            chargeType: item.chargeType,
            list: item.priceItemDetailList,
          };
        });
      });
      item.priceItemDetailList = res;
    },
    async submit() {
      if (!this.params.curriculumInfo.curriculumName.trim()) {
        this.$toast('请输入课程名称');
        return;
      }
      if (this.params.availableCampusIds.length == 0) {
        this.$toast('请选择可用校区');
        return;
      }
      if (this.manual.priceItemDetailList.length + this.auto.priceItemDetailList.length < 1) {
        this.$toast('请设置计费方式');
        return;
      }
      this.submiting = true;
      try {
        // 如果用户关闭开关，则在提交时清除对应价格
        !this.sw1_check && (this.manual.priceItemDetailList = []);
        !this.sw2_check && (this.auto.priceItemDetailList = []);
        let args = {
          ...this.params,
          priceItemDtos: [this.manual, this.auto],
        };

        // 编辑
        if (this.id) {
          await this.$api.updateCurriculumPriceItem(args);
          vant.Toast.success('修改课程成功');
        }
        // 新增
        else {
          await this.$api.newAddCurriculumPriceItem(args);
          vant.Toast.success('创建课程成功');
        }
        app.vue.$emit('courseInfosChangeSuccess');
        app.vue.$emit('courseListRefresh');
        this.submiting = false;
        this.$router.back();
      } catch (error) {
        console.error(error);
        this.submiting = false;
      }
    },
  },
  created() {
    this.render();
    // 监听选择更多定价维度
    this.$onBus('confirmChoosetPriceDimensions', this.handleDimensionData);
  },
};
</script>

<style lang="scss" scoped>
.add-course {
  display: flex;
  flex-direction: column;
  height: 100%;
  .tip1 {
    font-size:var(--fs-md);
    line-height:var(--lh-md);
    color: var(--c4);
    padding: 8px 16px;
  }
  .campus-box {
    display: flex;
    flex-wrap: wrap;
    background-color: var(--white);
    padding: calc(var(--gap) * 12) 0;
    .campus-name {
      display: flex;
      align-items: center;
      margin: 0 0 calc(var(--gap) * 12) calc(var(--gap) * 16);
      padding: calc(var(--gap) * 4) calc(var(--gap) * 8);
      background-color: var(--g1);
      border-radius: calc(var(--w) * 16);
      font-size: var(--fs-sm);
      line-height: var(--lh-sm);
      .delete-icon {
        margin-left: calc(var(--gap) * 4);
        font-size: var(--fs-sm);
        color: var(--g5);
      }
    }
  }

  .base-course-form {
    flex: 1;
    overflow-y: auto;
    padding-bottom: 24px;
    .txtbar {
      padding-top: calc(var(--gap) * 12);
      padding-left: calc(var(--gap) * 16);
      padding-right: calc(var(--gap) * 16);
      .txt {
        color: var(--g6);
        padding: calc(var(--gap) * 8) 0;
      }
    }
    .typebar {
      .txt {
        color: var(--g8);
        padding: calc(var(--gap) * 12) 0;
      }
    }
    .txtbar,
    .typebar {
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      display: flex;
      justify-content: space-between;
      align-items: center;
      .txtbtn {
        color: var(--c1);
      }
    }
  }

  .sub-wrap {
    position: relative;
    z-index: 2;
    overflow: hidden;
  }
  .no-dimens {
    padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    color: var(--g5);
    background: var(--white);
  }
  .cell-wrapper {
    padding: 0 calc(var(--gap) * 16);
    background: var(--white);
  }
}
.lab {
  display: flex;
  align-items: center;
  ::v-deep .van-popover__wrapper {
    display: flex;
    align-items: center;
    padding-left: 2px;
  }
}
</style>